// extracted by mini-css-extract-plugin
export default {"disclaimer":"disclaimer_disclaimer__dy7cn","disclaimer--alert":"disclaimer_disclaimer--alert__WoL+u"};